import { FeatureFlag } from "@/__generated__/graphql";

type ObjectWithFeatureFlags = {
  featureFlags?: FeatureFlag[];
};
export default function featureFlagEnabled(
  object: ObjectWithFeatureFlags | null | undefined,
  key: string
): boolean {
  const flag = object?.featureFlags?.find(flag => flag.key === key);

  return flag?.enabled ?? false;
}
